var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImageMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 208,
    viewBox: "0 0 332 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_13690)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 921.409,
    height: 483.622,
    transform: "translate(-295 -58)",
    fill: "#26253E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.266,
    cy: -3.05538,
    r: 3.81962,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.114 -57.9994V48.3613H196.526V-57.9994H197.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 52.1809,
    r: 3.81962,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.631,
    y: -24.0632,
    width: 81.3873,
    height: 52.5932,
    stroke: "#FFCFCD",
    strokeWidth: 0.88145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-119.298 46.5996H17.0334V59.5267V59.5275V121.228C17.0334 126.096 13.087 130.043 8.21887 130.043H-110.483C-115.351 130.043 -119.298 126.096 -119.298 121.228V59.5267L-119.298 59.5179V46.5996ZM16.1519 59.5275H-118.416V121.228C-118.416 125.61 -114.864 129.161 -110.483 129.161H8.21887C12.6002 129.161 16.1519 125.61 16.1519 121.228V59.5275ZM-99.3181 73.6293H3.51782C3.84236 73.6293 4.10545 73.8923 4.10545 74.2169V81.2685C4.10545 81.593 3.84236 81.8561 3.51782 81.8561H-99.3181C-99.6426 81.8561 -99.9057 81.593 -99.9057 81.2685V74.2169C-99.9057 73.8923 -99.6426 73.6293 -99.3181 73.6293ZM-100.493 74.2169C-100.493 73.5678 -99.9671 73.0416 -99.3181 73.0416H3.51782C4.1669 73.0416 4.69308 73.5678 4.69308 74.2169V81.2685C4.69308 81.9176 4.1669 82.4438 3.51782 82.4438H-99.3181C-99.9671 82.4438 -100.493 81.9176 -100.493 81.2685V74.2169ZM-107.545 87.1448H3.51781C3.84235 87.1448 4.10545 87.4079 4.10545 87.7325V94.7841C4.10545 95.1086 3.84236 95.3717 3.51781 95.3717H-107.545C-107.869 95.3717 -108.133 95.1086 -108.133 94.7841V87.7325C-108.133 87.4079 -107.869 87.1448 -107.545 87.1448ZM-108.72 87.7325C-108.72 87.0834 -108.194 86.5572 -107.545 86.5572H3.51781C4.16689 86.5572 4.69308 87.0834 4.69308 87.7325V94.7841C4.69308 95.4331 4.1669 95.9593 3.51781 95.9593H-107.545C-108.194 95.9593 -108.72 95.4331 -108.72 94.7841V87.7325ZM-49.3692 107.418C-49.3692 105.633 -47.9222 104.186 -46.1372 104.186H-36.1475C-34.3625 104.186 -32.9155 105.633 -32.9155 107.418C-32.9155 109.203 -34.3625 110.65 -36.1474 110.65H-46.1372C-47.9222 110.65 -49.3692 109.203 -49.3692 107.418ZM4.69308 101.836H-27.0391V102.423H4.69308V101.836ZM-27.0391 104.186H4.69308V104.774H-27.0391V104.186ZM4.69308 107.124H-27.0391V107.712H4.69308V107.124ZM-27.0391 109.475H4.69308V110.063H-27.0391V109.475Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.472 -35.3764H-17.9307V22.5058H105.472V-35.3764ZM-18.8122 -35.3764V22.5058H-18.8123V23.0934L-18.8122 23.1288V23.6808H-18.793C-18.4907 28.2751 -14.6685 31.9079 -9.99775 31.9079H97.5392C102.21 31.9079 106.032 28.2751 106.334 23.6808H106.354V22.7994V-35.3764V-36.2578H105.472H-17.9307H-18.8122V-35.3764ZM92.2505 -20.9794H38.7758V-14.5154H92.2505V-20.9794ZM38.7758 -21.567H38.1882V-20.9794V-14.5154V-13.9278H38.7758H92.2505H92.8381V-14.5154V-20.9794V-21.567H92.2505H38.7758ZM7.33737 -14.2213C7.33737 -10.6513 4.44335 -7.75733 0.873402 -7.75733C-2.69655 -7.75733 -5.59057 -10.6513 -5.59057 -14.2213C-5.59057 -17.7912 -2.69655 -20.6853 0.873402 -20.6853C4.44335 -20.6853 7.33737 -17.7912 7.33737 -14.2213ZM8.21882 -14.2213C8.21882 -10.1645 4.93016 -6.87588 0.873402 -6.87588C-3.18336 -6.87588 -6.47202 -10.1645 -6.47202 -14.2213C-6.47202 -18.2781 -3.18336 -21.5667 0.873402 -21.5667C4.93016 -21.5667 8.21882 -18.2781 8.21882 -14.2213ZM8.80648 6.34557C8.80648 6.83238 8.41184 7.22702 7.92503 7.22702C7.43822 7.22702 7.04358 6.83238 7.04358 6.34557C7.04358 5.85876 7.43822 5.46412 7.92503 5.46412C8.41184 5.46412 8.80648 5.85876 8.80648 6.34557ZM9.39411 6.34557C9.39411 7.15692 8.73638 7.81465 7.92503 7.81465C7.11368 7.81465 6.45595 7.15692 6.45595 6.34557C6.45595 5.53422 7.11368 4.87649 7.92503 4.87649C8.73638 4.87649 9.39411 5.53422 9.39411 6.34557ZM-5.00291 7.22702C-4.5161 7.22702 -4.12146 6.83238 -4.12146 6.34557C-4.12146 5.85876 -4.5161 5.46412 -5.00291 5.46412C-5.48972 5.46412 -5.88436 5.85876 -5.88436 6.34557C-5.88436 6.83238 -5.48972 7.22702 -5.00291 7.22702ZM-5.00291 7.81465C-4.19156 7.81465 -3.53382 7.15692 -3.53382 6.34557C-3.53382 5.53422 -4.19156 4.87649 -5.00291 4.87649C-5.81426 4.87649 -6.47199 5.53422 -6.47199 6.34557C-6.47199 7.15692 -5.81426 7.81465 -5.00291 7.81465ZM1.46106 7.81465C2.27241 7.81465 2.93015 7.15692 2.93015 6.34557C2.93015 5.53422 2.27241 4.87649 1.46106 4.87649C0.649708 4.87649 -0.00802231 5.53422 -0.00802231 6.34557C-0.00802231 7.15692 0.649708 7.81465 1.46106 7.81465ZM38.7758 -10.402H92.2505V-3.93802H38.7758V-10.402ZM38.1882 -10.9896H38.7758H92.2505H92.8381V-10.402V-3.93802V-3.35038H92.2505H38.7758H38.1882V-3.93802V-10.402V-10.9896ZM75.7967 3.70122H92.8381V8.40229H75.7967V3.70122Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.588,
    y: 172.115,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.484,
    y: 172.115,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.484,
    y: 143.218,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.588,
    y: 201.011,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.692,
    y: 201.011,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.796,
    y: 201.011,
    width: 23.7779,
    height: 23.7779,
    rx: 2.06429,
    stroke: "#FFCFCD",
    strokeWidth: 0.494781
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_130_13690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.718 172.01H216.445V196.282H240.718V172.01Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.573 178.035V182.592H222.471V185.626H231.573V190.171H234.607V178.035H231.573Z",
    fill: "#26253E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_13690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 921.409,
    height: 483.622,
    fill: "white",
    transform: "translate(-295 -58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_130_13690"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.445,
    y: 172.01,
    width: 24.2727,
    height: 24.2727,
    rx: 2.31168,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImageMobile);
export default __webpack_public_path__ + "static/media/HeroImageMobile.85f653f23013006522f34f05fa9e84cc.svg";
export { ForwardRef as ReactComponent };